module.exports = __webpack_public_path__ + "img/minus.c762fcc7.svg";